<template>
  <div>
    <div v-if="supplyPoint">
      <v-container
        fluid
        class="page-content page-body text-left pt-12 pb-6 d-flex"
      >
        <v-row class="page-container px-6 px-lg-0">
          <v-col class="sign-text-container">
            <h3>{{ supplyPoint.customer.salutation }},</h3>
            <div class="mt-8">
              <p>
                podle Vašich preferencí jsme Vám připravili férovou nabídku na
                odběr energie.
              </p>
              <p>
                Nyní od Vás potřebujeme podpisy pod dva dokumenty. Vše Vám
                zabere jen pár minut a o zbytek už se postaráme my v
                <strong>Yello</strong>.
              </p>
              <p>
                Nejprve si otevřete k&nbsp;podpisu plnou moc, která bývá potřeba
                pro&nbsp;zastupování u dodavatelů energií.
              </p>
              <p>
                Poté se Vám otevře možnost podepsání smlouvy s
                <strong>Yello</strong>. Ve smlouvě máte uvedenou nabídku a
                podmínky, za kterých k&nbsp;nám přestoupíte.
              </p>
              <p>
                Oba dokumenty máte před podpisem k&nbsp;dispozici, vše si můžete
                v klidu přečíst a prostudovat. Na konci stránky naleznete odkaz
                na obchodní podmínky a ceník nabídky, která platí do
                {{ expirationDate }}.
              </p>
              <p>
                Pokud&nbsp;budete chtít některý údaj v&nbsp;dokumentech upravit
                nebo se poradit, neváhejte&nbsp;nám zavolat&nbsp;na linku&nbsp;
                <a href="tel:267056704">
                  <strong>267&nbsp;056&nbsp;704</strong>
                </a>
                v&nbsp;pracovní dny
                od&nbsp;9&nbsp;do&nbsp;17&nbsp;hodin&nbsp;nebo napište na
                <strong>
                  <a href="mailto:yello@yello.cz">yello@yello.cz</a>
                </strong>
                a my vše vyřešíme.
              </p>
              <p>
                Děkujeme za důvěru v&nbsp;<strong>Yello</strong>
                a přejeme den plný pozitivní energie.
              </p>
              <p>
                <strong>Yello</strong>
              </p>
            </div>
          </v-col>
          <v-col>
            <v-row style="height: 100%">
              <v-col class="d-flex justify-center align-center">
                <SignCard
                  title="K PODEPSÁNÍ"
                  icon="authorization"
                  icon-description="Plná moc"
                  button-text="Podepsat plnou moc"
                  top-icon="step1"
                  class="ma-4"
                  :is-signed="isPoaSigned"
                  :is-signing="isSigning.poa"
                  :is-declined="isPoaDeclined"
                  :is-button-disabled="documents.length === 0"
                  @button-click="signDocument('POA')"
                />
              </v-col>
              <v-col class="d-flex justify-center align-center">
                <SignCard
                  title="K NÁHLEDU"
                  icon="contract"
                  icon-description="Smlouva"
                  :button-text="contractButtonText"
                  top-icon="step2"
                  class="ma-4"
                  :is-signed="isContractSigned"
                  :is-signing="isSigning.contract"
                  :is-declined="isContractDeclined"
                  :is-disabled="!isPoaSigned"
                  :is-button-disabled="documents.length === 0"
                  @button-click="
                    isPoaSigned
                      ? signDocument('CONTRACT')
                      : openDocumentPreviewDialog()
                  "
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-container
        fluid
        class="sign-page-content pt-12 pb-8 page-container text-body-2"
      >
        <p>
          Součásti smluvní dokumentace jsou i všeobecné obchodní podmínky, které
          si můžete zobrazit
          <a
            href="#"
            @click.prevent="
              openFilePreview(
                'Všeobecné obchodní podmínky',
                supplyPoint.files.terms
              )
            "
            >zde</a
          >.
        </p>
        <p>
          Doplňující informace pro spotřebitele před uzavřením smlouvy jsou
          dostupné
          <a href="#" @click.prevent="openAdditionalInfoDialog()">zde</a>.
        </p>
        <p>
          Úplné informace o zpracování osobních údajů jsou dostupné
          <a
            href="https://www.yello.cz/cs/ochrana-osobnich-udaju/"
            target="_blank"
            >zde</a
          >.
        </p>
        <p>
          A také Váš ceník, který si můžete zobrazit
          <a
            href="#"
            @click.prevent="
              openFilePreview('Ceník', supplyPoint.files.productCatalog)
            "
            >zde</a
          >.
        </p>
        <p>
          <strong> Vaše Yello </strong>
        </p>
      </v-container>
    </div>
    <v-progress-linear v-else indeterminate />
    <DocumentPreviewDialog
      v-model="isDialogVisible"
      :title="dialogTitle"
      :file-type="dialogFileType"
      :file-uuid="dialogFileUuid"
      :file-name="dialogFileName"
    />
  </div>
</template>

<script>
import SignCard from "@/components/SignCard.vue";
import DocumentPreviewDialog from "@/components/DocumentPreviewDialog.vue";
import { setApiKeyToSessionStorage } from "@/utils/sessionStorage";
import downloadFile from "@/utils/downloadFile";
import http from "@/http";

export default {
  name: "SignPage",
  components: {
    SignCard,
    DocumentPreviewDialog,
  },
  data: () => ({
    supplyPoint: undefined,
    documents: [],
    isDialogVisible: false,
    dialogTitle: undefined,
    dialogFileType: undefined,
    dialogFileUuid: undefined,
    dialogFileName: undefined,
    isSigning: {
      poa: false,
      contract: false,
    },
  }),
  computed: {
    expirationDate() {
      return new Date(this.supplyPoint.offerExpireAt).toLocaleDateString(
        "cs-CZ"
      );
    },
    isPoaSigned() {
      return !!this.documents.find(
        (document) =>
          document.type.id === "POA" && document.status.id === "SIGNED"
      );
    },
    isPoaDeclined() {
      return !!this.documents.find(
        (document) =>
          document.type.id === "POA" && document.status.id === "DECLINED"
      );
    },
    isContractSigned() {
      return !!this.documents.find(
        (document) =>
          document.type.id === "CONTRACT" && document.status.id === "SIGNED"
      );
    },
    isContractDeclined() {
      return !!this.documents.find(
        (document) =>
          document.type.id === "CONTRACT" && document.status.id === "DECLINED"
      );
    },
    contractButtonText() {
      return this.isPoaSigned ? "Podepsat smlouvu" : "Prohlédnout smlouvu";
    },
  },
  created() {
    if (this.$route.query.h) {
      setApiKeyToSessionStorage(this.$route.query.h);
    }
    this.loadSupplyPoint();
    this.loadDocuments();
  },
  methods: {
    canOpenFilesInPopup() {
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      const isSupported = !!iframe.contentWindow;
      document.body.removeChild(iframe);
      return isSupported;
    },
    async signDocument(documentType) {
      this.isSigning[documentType.toLowerCase()] = true;
      const document = this.documents.find(
        (document) => document.type.id === documentType
      );
      const response = await http.get(
        `customer/supply-point/document/${document.file.uuid}/sign`
      );
      this.isSigning[documentType.toLowerCase()] = false;
      window.location.href = response.data.redirectUrl;
    },
    async openDocumentPreviewDialog() {
      const doc = this.documents.find(
        (document) => document.type.id === "CONTRACT"
      );
      const fileType = "document";
      if (!this.canOpenFilesInPopup()) {
        await downloadFile(fileType, doc.file.uuid);
        return;
      }
      this.dialogFileType = fileType;
      this.dialogFileUuid = doc.file.uuid;
      this.dialogFileName = undefined;
      this.dialogTitle = doc.file.name;
      this.isDialogVisible = true;
    },
    async openFilePreview(title, file) {
      const fileType = "upload";
      if (!this.canOpenFilesInPopup()) {
        await downloadFile(fileType, file.uuid);
        return;
      }
      this.dialogFileType = fileType;
      this.dialogFileUuid = file.uuid;
      this.dialogFileName = undefined;
      this.dialogTitle = title;
      this.isDialogVisible = true;
    },
    async openAdditionalInfoDialog() {
      this.dialogTitle = "Doplňující informace";
      this.dialogFileName = "Doplňující_informace_pro_spotřebitele.pdf";
      this.isDialogVisible = true;
    },
    async loadSupplyPoint() {
      const response = await http.get("customer/supply-point");
      this.supplyPoint = response.data;
    },
    async loadDocuments() {
      const response = await http.get("customer/supply-point/document");
      this.documents = response.data;
    },
  },
};
</script>

<style scoped>
.sign-text-container {
  max-width: 600px;
}

@media (max-width: 1280px) {
  .sign-text-container {
    min-width: 100%;
  }
}

a {
  text-decoration: none;
}
</style>
